import { Image } from 'expo-image';
import React from 'react';
import { Platform, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import WebView from 'react-native-webview';

import { Text } from '@/ui';

interface Instruction {
  id: number;
  image?: string;
  instruction: string;
  title: string;
  video?: string;
}

interface DynamicInstructionProps {
  instruction: Instruction;
}

export default function DynamicInstruction({
  instruction,
}: DynamicInstructionProps) {
  const { styles, theme } = useStyles(stylesheet);
  const [loadingAsset, setLoadingAsset] = React.useState(true);

  return (
    <View style={styles.container}>
      <View style={{ gap: 8 }}>
        <Text type="title1">{instruction.title}</Text>

        <Text type="bodyRegular" style={{ color: theme.colors.text.secondary }}>
          {instruction.instruction}
        </Text>
      </View>

      <View style={{ width: '100%' }}>
        {/* {loadingAsset ? <ActivityIndicator size="small" /> : null} */}

        {instruction.image ? (
          <Image
            source={{ uri: instruction.image }}
            contentFit="cover"
            style={{
              width: '100%',
              height: 250,
              borderRadius: 16,
            }}
            onLoadStart={() => {
              setLoadingAsset(true);
            }}
            onLoadEnd={() => {
              setLoadingAsset(false);
            }}
          />
        ) : null}

        {instruction.video ? (
          <View
            style={{
              width: '100%',
              height: 300,
            }}
          >
            {Platform.OS === 'web' ? (
              <iframe
                src={instruction.video}
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none',
                  borderRadius: 16,
                }}
                allowFullScreen
                onLoadStart={() => {
                  setLoadingAsset(true);
                }}
                onLoad={() => {
                  setLoadingAsset(false);
                }}
              />
            ) : (
              <View
                style={{ flexGrow: 1, borderRadius: 16, overflow: 'hidden' }}
              >
                <WebView
                  javaScriptEnabled
                  domStorageEnabled
                  source={{ uri: instruction.video }}
                  onLoadStart={() => {
                    setLoadingAsset(true);
                  }}
                  onLoadEnd={() => {
                    setLoadingAsset(false);
                  }}
                  style={{
                    borderRadius: 16,
                  }}
                />
              </View>
            )}
          </View>
        ) : null}
      </View>
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    minWidth: '100%',
    gap: 16,
    backgroundColor: theme.colors.background_1,
  },
}));
